export default __webpack_public_path__ + "static/media/close-modal.9921df7d.svg";